export default "__VITE_ASSET__DLIbk0T3__"